var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout", [
    !_vm.isGrantedBookKeeper
      ? _c(
          "div",
          { staticClass: "is-user-dashboard" },
          [
            _c(
              "div",
              [
                _c("orders", {
                  ref: "ordersComponent",
                  on: {
                    refreshTodos: _vm.refreshTodos,
                    openTagsForm: function ($event) {
                      return _vm.$refs.tagsForm.openWithRow($event)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "collapsible-rail",
                  {
                    staticClass: "is-hidden-mobile is-hidden-tablet-only",
                    attrs: { "storage-key": "userDashboardTodosCollapsed" },
                  },
                  [_c("todos", { ref: "todosComponent" })],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("tour"),
            _vm._v(" "),
            _c("tags-form", {
              ref: "tagsForm",
              on: {
                saved: function ($event) {
                  return _vm.$refs.ordersComponent.refreshTable()
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }